import { PropDefaults } from '@/src/types';
interface ContainerProps extends PropDefaults {}
export const Container: React.FC<ContainerProps> = ({ children }) => {
  return <div className="flex flex-col">{children}</div>;
};
